import { useSyncExternalStore } from "react";
import { z } from "zod";

import { readStored, writeStored } from "@/lib/storage";

/** UI theme (FR-PROJ-085): system, light or dark, per browser. The drawing canvas has its own setting in Draft. */
export type ThemePreference = "system" | "light" | "dark";

const STORAGE_KEY = "orthos.theme";
const schema = z.enum(["system", "light", "dark"]);
const listeners = new Set<() => void>();
let current: ThemePreference = readStored(STORAGE_KEY, schema) ?? "system";

/** Sets data-theme on <html>; "system" removes it so tokens.css follows the OS preference. */
export function applyTheme(theme: ThemePreference = current): void {
  const root = document.documentElement;
  if (theme === "system") delete root.dataset.theme;
  else root.dataset.theme = theme;
}

export function setTheme(theme: ThemePreference): void {
  current = theme;
  writeStored(STORAGE_KEY, theme);
  applyTheme(theme);
  for (const listener of listeners) listener();
}

export function useTheme(): ThemePreference {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => current,
  );
}
